<template>
  <div :class="['page-wrapper', 'p-case-lobby', ('bg-' + lobbyBG), 'center-md']">

    <menu-co></menu-co>

      <div class="lobby-type">
        <div :class="['lobby-icon', $lang[$route.params.case].icon]"></div>
        <h3 class="case-name">{{ $lang[$route.params.case].lobby_header }}</h3>
        <p class="case-title">{{ $lang[$route.params.case].lobby_desc }}</p>
        <div class="btn green dark-hover" v-touch:tap="moveOnCase">{{ $lang.case_lobby.button }}</div>
      </div>

  </div>
</template>

<script>
  import Menu from '../../../components/menu/'
  import dataContext from '../../../assets/data/context.json'

  export default {
    name: 'case-case-lobby',
    data () {
      return {
        context: dataContext.current_context,
        lobbyBG: this.$route.params.case
      }
    },
    props: ['props'],
    beforeMount () {
      this.$nextTick(function () {
        window.scrollTo(0, 0)
      })
    },
    mounted () {
      this.util.addBodyClass('dark-bg')
    },
    methods: {
      moveOnCase () {
        this.$bus.$emit('LOADER.SHOW')
        this.$router.push({ path: `/${this.$route.params.case}`, props: {case_context: this.context} })
      }
    },
    beforeDestroy () {
      this.util.removeBodyClass('dark-bg')
    },
    components: {
      'menu-co': Menu
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/content/case-lobby/index.vue